import React from 'react';
import { useSelector } from 'react-redux';
import { SearchProps } from '../../pages/arc/models/arc-epi-props';
import { TcsmStates } from '../../root/tcsm-model';
import { SortLabel } from '../components/sort-label';
import { FilterTypes } from '../models/search-models';

export function BenefitGroupChangeLogLabels() {

    const searchSettings = useSelector<TcsmStates, SearchProps>(state => state?.epiProps?.searchSettingsState?.epiContent);

    return (
        <div className='sort-table-row'>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.submittedDate} labelText={searchSettings?.submittedDateLabel} />
            </div>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.lastActivityDate} labelText={searchSettings?.lastActivityDateLabel} />
            </div>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.status} labelText={searchSettings?.statusRowLabel} />
            </div>
            <div className='sort-table-row-cell sort-table-row-cell-lg'>
                <SortLabel type={FilterTypes.eventType} labelText={searchSettings?.eventTypeLabel} />
            </div>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.requestBy} labelText={searchSettings?.requestByLabel} />
            </div>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.completed} labelText={searchSettings?.completedLabel} />
            </div>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.changeMadeFor} labelText={searchSettings?.changeMadeForLabel} />
            </div>
            <div className='sort-table-row-cell'>
                <SortLabel type={FilterTypes.changeType} labelText={searchSettings?.changeTypeLabel} />
            </div>
        </div>

    );
}
